'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.CdsImage = exports.getPicParams = exports.setCdsBaseUrl = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _ThreeBounce = require('../ThreeBounce/ThreeBounce');

var _reactLayoutComponents = require('react-layout-components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var classnames = require('classnames');

var CDS_BASE_URL = "http://no_baseurl_set";

var setCdsBaseUrl = exports.setCdsBaseUrl = function setCdsBaseUrl(url) {
	CDS_BASE_URL = url;
};

var getUrlByLanguageCode = function getUrlByLanguageCode(urlDictOrString, languageCode) {
	if (typeof urlDictOrString === "string") {
		return urlDictOrString;
	}

	var ret = _lodash2.default.get(urlDictOrString, languageCode, null);
	if (ret != null) {
		return ret;
	} else {
		var givenLanguages = ["ALL", "EN", "DE", "FR"];
		var result = givenLanguages.filter(function (lc) {
			return _lodash2.default.get(urlDictOrString, lc, null) != null;
		});
		if (result.length != 0) {
			return urlDictOrString[result[0]];
		} else {
			return "";
		}
	}
};
var getPicParams = exports.getPicParams = function getPicParams(realOptions) {
	var options = Object.assign({}, {
		src: null,
		asset: null,
		width: 200,
		height: 150,
		fallback: true,
		grayscale: false,
		watermark: false
	}, realOptions);

	var baseurl = CDS_BASE_URL;
	var languageCodeURL = getUrlByLanguageCode(options.asset.URL, options.languageCode);
	var s = options.src;
	if (options.src == null) {
		if (options.asset == null) return null;
		if (options.asset.URL_TYPE !== 'CDS') return null;
		s = languageCodeURL;
	}

	var pathForAssetType = '/catalog/product/' + s[0] + '/' + s[1] + '/';

	var nudeleds = s.startsWith('/') ? s : pathForAssetType + s;

	var params = {};
	if (options.width !== undefined) {
		params['WIDTH'] = options.width;
		params['HEIGHT'] = options.height;
		params['GRAYSCALE'] = options.grayscale;
		params['WATERMARK'] = options.watermark;
		params['fallback'] = options.fallback;
	}
	var requrl = Object.entries(params).map(function (_ref) {
		var _ref2 = _slicedToArray(_ref, 2),
		    k = _ref2[0],
		    v = _ref2[1];

		return encodeURIComponent(k) + '=' + encodeURIComponent(v);
	}).join('&');
	var url = baseurl + '/image' + nudeleds + '?' + requrl;

	var ret = {
		width: options.width,
		height: options.height,
		url: url
	};

	if (typeof options.asset.CAPTION.ALL !== "undefined") {
		ret.alt = options.asset.CAPTION.ALL;
	}

	return ret;
};

var CdsImage = exports.CdsImage = (_temp = _class = function (_React$Component) {
	_inherits(CdsImage, _React$Component);

	function CdsImage(props) {
		_classCallCheck(this, CdsImage);

		var _this = _possibleConstructorReturn(this, (CdsImage.__proto__ || Object.getPrototypeOf(CdsImage)).call(this, props));

		_this.state = {
			loading: true
		};
		return _this;
	}

	_createClass(CdsImage, [{
		key: 'handleOnLoaded',
		value: function handleOnLoaded() {
			this.setState({ loading: false });
		}
	}, {
		key: 'render',
		value: function render() {
			var responsive = this.props.responsive;


			var picParams = getPicParams({
				src: this.props.src,
				asset: this.props.asset,
				width: this.props.width,
				height: this.props.height,
				fallback: this.props.fallback,
				grayscale: this.props.grayscale,
				watermark: this.props.watermark,
				languageCode: _lodash2.default.get(this.props, "languageCode", "ALL")
			});

			if (responsive) {
				return this.renderResponsive(picParams);
			} else {
				return this.renderNonResponsive(picParams);
			}
		}
	}, {
		key: 'renderResponsive',
		value: function renderResponsive(picParams) {
			var caption = this.props.asset != null ? this.props.asset.CAPTION : this.props.caption;

			return _react2.default.createElement(
				_react.Fragment,
				null,
				_react2.default.createElement(
					_reactLayoutComponents.Box,
					{ flex: true, column: true,
						style: {
							width: '100%',
							paddingTop: '75%',
							position: 'relative'
						},
						className: classnames({
							'loading': this.state.loading
						})
					},
					_react2.default.createElement(
						_reactLayoutComponents.Box,
						{ fit: true, center: true, style: {
								// border: '1px solid purple',
								background: this.state.loading ? '#f8f8f8' : '#fff',
								position: 'absolute',
								top: 0,
								left: 0
							} },
						_react2.default.createElement(_ThreeBounce.ThreeBounce, { style: {
								display: this.state.loading ? 'block' : 'None'
							} }),
						_react2.default.createElement(_reactBootstrap.Image, {
							src: picParams.url,
							responsive: true,
							style: {
								display: this.state.loading ? 'None' : 'block'
							},
							onLoad: this.handleOnLoaded.bind(this),
							alt: caption
						})
					)
				)
			);
		}
	}, {
		key: 'renderNonResponsive',
		value: function renderNonResponsive(picParams) {

			var caption = this.props.asset != null ? this.props.asset.CAPTION : this.props.caption;

			return _react2.default.createElement(
				_react.Fragment,
				null,
				_react2.default.createElement(
					_reactLayoutComponents.Box,
					{ flex: true, column: true,
						style: {
							width: picParams.width,
							height: picParams.height

							// paddingTop: '75%',
						},
						className: classnames({
							'loading': this.state.loading
						})
					},
					_react2.default.createElement(
						_reactLayoutComponents.Box,
						{ fit: true, center: true, style: {
								// border: '1px solid purple',
								background: '#eee'

							} },
						_react2.default.createElement(_ThreeBounce.ThreeBounce, { style: {
								display: this.state.loading ? 'block' : 'None'
							} }),
						_react2.default.createElement(_reactBootstrap.Image, {
							src: picParams.url,
							width: picParams.width,
							height: picParams.height,
							style: {
								display: this.state.loading ? 'None' : 'block'
							},
							onLoad: this.handleOnLoaded.bind(this),
							alt: caption
						})
					)
				)
			);
		}
	}]);

	return CdsImage;
}(_react2.default.Component), _class.propTypes = {
	asset: _propTypes2.default.object,
	src: _propTypes2.default.string,
	width: _propTypes2.default.number,
	height: _propTypes2.default.number,
	grayscale: _propTypes2.default.bool,
	responsive: _propTypes2.default.bool,
	fallback: _propTypes2.default.bool,
	watermark: _propTypes2.default.bool,
	caption: _propTypes2.default.any,
	languageCode: _propTypes2.default.string
}, _class.defaultProps = {
	src: null,
	asset: null,
	width: 200,
	height: 150,
	fallback: true,
	grayscale: false,
	responsive: false,
	watermark: false,
	caption: null,
	languageCode: "ALL"
}, _temp);